import React from "react";
import { useTranslation } from "react-i18next";
import { QuickActionsContainer, QuickActionButton } from "./chatbot.styled";

const actions = [
  {
    key: "editAssets",
    prompt: "How to edit Assets?",
  },
  {
    key: "changeSiteSettings",
    prompt: "How to change Site Settings?",
  },
];

const ChatQuickActions = ({ onSelect, disabled }) => {
  const { t } = useTranslation();
  return (
    <QuickActionsContainer>
      {actions.map((action) => (
        <QuickActionButton
          type="button"
          key={action.key}
          onClick={() => onSelect(action.prompt)}
          disabled={disabled}
          aria-label={t('chatbot.aria.quickAction', {
            action: t(`chatbot.quickActions.${action.key}`)
          })}
        >
          {t(`chatbot.quickActions.${action.key}`)}
        </QuickActionButton>
      ))}
    </QuickActionsContainer>
  );
};

export default ChatQuickActions;
